import { createContext } from 'react';
import { Reference } from 'src/careflow/ph-core/fhir-client/resources';
import { MenuTaskHandler, TaskHandlerByType } from 'src/careflow/helpers/types';

export interface TaskContextData {
  rowDblClickHandlers?: TaskHandlerByType[];
  menuTaskHandlers?: MenuTaskHandler[];
  basedOn?: Reference[];
  taskActivityDefinitionContext?: string[];
  filterTasksFromChecklistItem?: {
    listFilter: string[];
    subListFilter: string[];
    owner?: string[];
    status?: string[];
  };
  isWorkflowContext?: boolean;
}

const initialTaskContextData: TaskContextData = {
  rowDblClickHandlers: [],
  menuTaskHandlers: [],
};

const TaskContext = createContext<TaskContextData>(initialTaskContextData);

export default TaskContext;
